module.exports = __webpack_public_path__ + "img/machinist-thumb.72f6c9df.jpg";